document.querySelectorAll( '.whippet-wholesale-ordering .quantity' ).forEach( widget => {
	const minus = widget.querySelector( '.minus' );
	const plus = widget.querySelector( '.plus' );
	const input = widget.querySelector( 'input' );
	
	if( minus && plus && input ) {
		minus.addEventListener( 'click', () => {
			const newValue = Number( input.value ) - 1;
			
			if( newValue >= input.min ) {
				input.value = newValue;
			}
			
			onInputChange();
		} );

		plus.addEventListener( 'click', () => {
			const newValue = Number( input.value ) + 1;

			if( newValue <= input.max ) {
				input.value = newValue;
			}
			
			onInputChange();
		} );
		
		function onInputChange() {
			const inputValue = Number( input.value );

			minus.disabled = inputValue <= input.min;
			plus.disabled = inputValue >= input.max;
		}
		
		input.addEventListener( 'change', onInputChange );
		onInputChange();
	}
} );
